import { ReactElement, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { Modal } from 'components'
import useUserService from 'services/userService'
import { successToast } from 'utils/toastService'

interface Props {}

const useDeleteUserModal = ({}: Props): [ReactElement, (args: any) => void] => {
  const queryClient = useQueryClient()
  const { deleteUser } = useUserService()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [userId, setUserId] = useState<string>()

  const mutation = useMutation(deleteUser, {
    onSuccess: () => {
      void queryClient.invalidateQueries('fetch-companies')
      void queryClient.invalidateQueries('users-list')
      toggleModal()
      successToast('User has been deleted')
    },
    onError: (error: any) => {
      toast.error(error?.detail || 'Can not delete user')
    },
  })

  const onClick = () => {
    mutation.mutate(userId)
  }

  const toggleModal = () => setIsOpen(!isOpen)

  return [
    <Modal
      isOpen={isOpen}
      title={'Delete Company'}
      okButtonType="submit"
      onConfirm={onClick}
      onClose={toggleModal}
      onConfirmButtonText={'Ok'}
    >
      <Box display={'flex'} flexDirection="column" px={'30px'}>
        <Typography
          fontSize="22px"
          fontWeight={'900'}
          align="center"
          width={'320px'}
        >
          Are you sure you want to delete the User ?
        </Typography>
      </Box>
    </Modal>,
    (id: string) => {
      toggleModal()
      setUserId(id)
    },
  ]
}

export default useDeleteUserModal
